var exports = {
  "S": "x93eb46d8--6148d7--image",
};

module.exports = exports;
